import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sales-groups',
  templateUrl: './sales-groups.component.html',
  styleUrls: ['./sales-groups.component.scss']
})
export class SalesGroupsComponent implements OnInit {

  hideQuotePurchase:any;
  checkOVRInAgencyCode: any;
  leadStatus: any;
  constructor(public router: Router,public user: UserService) { }

  ngOnInit(): void {
    this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
    this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
    this.getDashboard();
  }
  isDisabled: boolean = false;
  goToQuotePurchase(){
    if(this.isDisabled){
      return;
    }
    if(this.hideQuotePurchase!="true"){
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }else{
      Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          this.leadStatus=data.data.leads.leadStatus;
          if(this.leadStatus == 'Deactivated'){
            this.isDisabled = true;
          } else{
            this.isDisabled = false;
          }
         }, error => {
        }, () => { });
  }
}
